/**
 * ## @visiba/std
 *
 * Splits a string into initials.
 *
 * @example
 * ```ts
 * import { createInitials } from '@visiba/std';
 *
 * createInitials('first'); // 'F'
 * createInitials('first second'); // 'FS'
 * createInitials('first second third'); // 'FT'
 * ```
 */
export function createInitials(commonName: string): string;
/**
 * ## @visiba/std
 *
 * Splits a string into initials, with a custom separator.
 *
 * @example
 * ```ts
 * import { createInitials } from '@visiba/std';
 *
 * createInitials('first', '-'); // 'F'
 * createInitials('first second', '-'); // 'F-S'
 * createInitials('first second third', '-'); // 'F-T'
 * ```
 */
export function createInitials(commonName: string, separator: string): string;
export function createInitials(commonName: string, separator?: string): string {
	const parts = commonName.trim().split(' ');
	if (parts.length === 0) {
		return '';
	}

	const firstPart = parts[0].charAt(0).toUpperCase();
	if (parts.length === 1) {
		return firstPart;
	}

	const secondPart = (parts[parts.length - 1] ?? '').charAt(0).toUpperCase();

	return firstPart + (separator ?? '') + secondPart;
}
